import { Component, Input, Optional } from '@angular/core';
import { TeamReportServiceService } from './../../team-report/team-report-service.service'
import { HttpClient } from '@angular/common/http';
import { OrgIndividualTeamsComponent } from '../../org-individual-teams/org-individual-teams.component';
import { environment } from './../../../../environments/environment';
import { OrgsComponent } from '../../orgs/orgs.component';

@Component({
  selector: 'app-roster-add-member-popup',
  templateUrl: './roster-add-member-popup.component.html',
  styleUrls: ['./roster-add-member-popup.component.scss']
})
export class RosterAddMemberPopupComponent {

  bodyText:string;
  delBodyText:string;
  emails = "";
  fromOrgs = 0;
  constructor(public teamReportService: TeamReportServiceService, @Optional() public orgIndivTeams: OrgIndividualTeamsComponent, public http:HttpClient, public injectedOrgComp : OrgsComponent
  ){}
  
  ngOnInit() {
    console.warn('====>',this.orgIndivTeams?.modalSvc?.removeRosterMemDetails)
    // this.email = localStorage.getItem('email')
    // this.teamReportService.rosterName.subscribe((name)=> {
    //   this.bodyText = `FourSight Team,&#10;Please add the following members to my roster.&#10;&#10;Roster name: ${name}&#10;Account Email: ${this.email}&#10;&#10;New Members&#10;&#10;Name 1, Email 1&#10;Name 2, Email2&#10;•••`;
    //   this.delBodyText = `FourSight Team,&#10;Please delete the following member of my roster.&#10;&#10;Roster name: ${name}&#10;Account Email: ${this.email}&#10;&#10;Email of member&#10;${this.orgIndivTeams?.removeRosterMemDetails?.default_identity?.email}`;
    // })
  }

  public copyText(id,i) {
    let el = document.querySelectorAll('.cpy')[i];
    el?.classList.add('cpy--cpd');
    setTimeout(() => {
      el?.classList.remove('cpy--cpd');
      el?.classList.remove('cpy--txtar');
    }, 1000);
    let copyText;
    if(id == 'body-content') {
      el?.classList.add('cpy--txtar');
      copyText = document.getElementById(id);
      copyText?.select();
      copyText?.setSelectionRange(0, 99999);
      navigator.clipboard.writeText(copyText.value);
    } else {
      copyText = id;
      navigator.clipboard.writeText(copyText);
    }
  }

  // public addEmail() {
  //   this.emails.push({email: ''});
  // }

  // public removeEmail(index) {
  //   this.emails.splice(index, 1);
  // }

  public close() {
    // this.emails = [{email: ''}];
    this.emails = "";
    if (this.orgIndivTeams) this.orgIndivTeams.modalSvc.showRosterAddMemPopup = false;
    $('.roster_popup').css('display','none');
    $('.roster_addmem_popup').css('display','none');

  }

  public addRosterMember() {
    var that = this;
    if (this.orgIndivTeams) this.orgIndivTeams.loading = true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const payloadFormat = this.emails.split(",")
    .map(email => email.trim())      // Remove spaces
    .filter(email => emailRegex.test(email))  // Keep only valid emails
    .map(validEmail => ({ email: validEmail })); // Convert to object
    let data = {
      members_attributes: payloadFormat
    }

    let rosterId = this.orgIndivTeams?.id || this.injectedOrgComp.rosterId;

    if(rosterId == this.orgIndivTeams?.demo_roster_id){
      // this.emails = [{email: ''}]
      this.emails = "";
      this.orgIndivTeams?.addAcmeRosterTeamMemberFn(data)
    }else{
      console.log("my roster id",rosterId)
      if(rosterId && data?.members_attributes?.length > 0){
        this.http.post(`${environment.profileURL}/api/v1/roster_organizations/${rosterId}/add_members.json`,data).subscribe((res:any)=> {
          if(res){
            if(this.orgIndivTeams?.id){
              // this.orgIndivTeams.teamsData.members = res.memberships
              this.orgIndivTeams?.roasterMembers();
            }
            if (that.orgIndivTeams) that.orgIndivTeams.loading = false;
            if(this.injectedOrgComp.rosterId && this.injectedOrgComp.rosterId != null){
              this.injectedOrgComp.getDataFn()
            }
            // this.emails = [{email: ''}];
            this.emails = "";
            if (this.orgIndivTeams) this.orgIndivTeams.modalSvc.showRosterAddMemPopup = false;
            $('.roster_popup').css('display','none');
            $('.roster_addmem_popup').css('display','none');
            setTimeout(function () {
                  this.toastr.options = {
                    closeButton: true,
                    progressBar: true,
                    timeOut: 2000,
                  };
                  this.toastr.success(
                    "Members Added Successfully!",
                    "Nice!"
                  );
            }, 1000);
            

          }
        }, error=> {
          console.log(error)
          if (this.orgIndivTeams) this.orgIndivTeams.loading = false;
          setTimeout(function () {
                this.toastr.options = {
                  closeButton: true,
                  progressBar: true,
                  timeOut: 2000,
                };
                this.toastr.error(
                  "Something went wrong!",
                  "Oops!"
                );
              }, 1000);
        })
      } else {
        setTimeout(function () {
          this.toastr.options = {
            closeButton: true,
            progressBar: true,
            timeOut: 2000,
          };
          this.toastr.error(
            "Invalid email address!",
            "Oops!"
          );
        }, 1000);
        if (this.orgIndivTeams) this.orgIndivTeams.loading = false;
      }
    }
  }

  private cascadeRemoveFromTeams(member: any): void {
    const teamsNames = member?.teams_names || {};
    Object.entries(teamsNames).forEach(([teamId, teamName]: [string, any]) => {
      if (teamName === 'Unassigned' || teamName === 'Admin') return;
      const team = this.orgIndivTeams?.teams?.find((t: any) => String(t.id) === String(teamId));
      if (!team) return;
      // filter returns a new array so Angular *ngFor detects the change
      team.memberships = (team.memberships || []).filter((mbr: any) =>
        String(mbr.member_id) !== String(member.id) && String(mbr.id) !== String(member.id)
      );
      if (team.memberships_count > 0) team.memberships_count -= 1;
    });
    // rebuild allTeamIdsTtl so team counts update in the header
    if (this.orgIndivTeams?.teams) {
      this.orgIndivTeams.allTeamIdsTtl = this.orgIndivTeams.teams.map((t: any) => ({
        teamId: t.id,
        showMember: this.orgIndivTeams.defaultShowingMembers,
        teamName: t.name,
        memberships_count: t.memberships_count,
      }));
    }
  }

  public realTeamCount(teamsNames: any): number {
    if (!teamsNames) return 0;
    return Object.values(teamsNames).filter((v: any) => v !== 'Unassigned' && v !== 'Admin').length;
  }

  public realTeamNames(teamsNames: any): string[] {
    if (!teamsNames) return [];
    return Object.values(teamsNames).filter((v: any) => v !== 'Unassigned' && v !== 'Admin') as string[];
  }

  deleteRosterMember(mem:any) {
    var that = this;
    if (this.orgIndivTeams) this.orgIndivTeams.loading = true;
    console.log("member details",mem)
    let membership_ids = {members_ids :[mem.id]};
    if(this.orgIndivTeams?.id == this.orgIndivTeams?.demo_roster_id){
      this.orgIndivTeams?.deleteAcmeRosterTeamMemberFn(mem)
    }else{
      this.http.post(`${environment.profileURL}/api/v1/roster_organizations/${this.orgIndivTeams?.id}/remove_members`,membership_ids).subscribe((res:any)=> {
      if (that.orgIndivTeams) that.orgIndivTeams.modalSvc.showRosterAddMemPopup = false;
      console.log('res',res)
      if (that.orgIndivTeams) that.orgIndivTeams.loading = false;
      this.cascadeRemoveFromTeams(mem);
      that.orgIndivTeams?.roasterMembers();
    }, error=> {
      console.log(error)
      if (this.orgIndivTeams) this.orgIndivTeams.modalSvc.showRosterAddMemPopup = false;
      if (this.orgIndivTeams) this.orgIndivTeams.loading = false;
      setTimeout(function () {
            this.toastr.options = {
              closeButton: true,
              progressBar: true,
              timeOut: 2000,
            };
            this.toastr.error(
              "Something went wrong!",
              "Oops!"
            );
      }, 1000);
    })}
  }
}
